<videojs-live *ngIf="url && (compat === 'no' || !ivs)" [url]="url" [livestreamId]="livestreamId"></videojs-live>
<ivs-live *ngIf="url && compat === 'yes' && ivs" [url]="url" [livestreamId]="livestreamId"></ivs-live>

<div class="live-button-container" dpadZone>
    <div class="back-button-wrapper">
        <button #backButton (click)="returnToPreviousPage()" class="shaka-overlay-button overlay-button dpad-start" [class.shown]="showBack" aria-label="Skip Forward" dpadSelectable>
            <svg viewBox="0 0 64 64" width="64" height="64">
                <circle class="button-circle" r="32" cy="32" cx="32"></circle>
                <g transform="matrix(1, 0, 0, 1, 0.975134, 1.378108)">
                    <path class="button-icon"
                          d="m31.46173,20.0921c0.24744,0 0.48475,0.09155 0.65974,0.25452c0.17497,0.16296 0.27327,0.38399 0.27327,0.61444l0,19.11727c0,0.15101 -0.04222,0.29942 -0.12256,0.4306c-0.08034,0.13118 -0.19599,0.24059 -0.33554,0.31746c-0.13956,0.07685 -0.29823,0.11852 -0.46034,0.12088c-0.16214,0.0024 -0.32212,-0.03468 -0.46418,-0.10745l-18.66025,-9.55863c-0.14639,-0.07497 -0.26848,-0.18519 -0.35352,-0.31915c-0.08504,-0.13393 -0.12991,-0.28668 -0.12991,-0.44228c0,-0.15562 0.04487,-0.30837 0.12991,-0.4423c0.08504,-0.13395 0.20713,-0.24417 0.35352,-0.31915l18.66025,-9.55863c0.13775,-0.07053 0.29242,-0.10755 0.44963,-0.10757z">
                    </path>
                </g>
                <g transform="matrix(1, 0, 0, 1, 0.975134, 1.378108)">
                    <rect class="button-icon" stroke="null" x="28.46136" y="28.05648" height="6.22732"
                          width="23.14268">
                    </rect>
                </g>
            </svg>
        </button>
    </div>
</div>

